<template>
  <div id="contenedor-principal-reportederelaciondechequescobrados" style="position:relative;">
    <div id="contenedor-encabezados-reportederelaciondechequescobrados" class="text-left">
      <h1>Reporte de relación de cheques cobrados</h1>
      
    </div>
    <div id="contenedor-principal-reportederelaciondechequescobrados" class="row mt-3">
      <!-- Filtro de Búsqueda -->
      <transition name="fade">
      
      <div id="contenedor-filtros-reportederelaciondechequescobrados" class="col-12 col-sm-12 col-md-12 col-lg-4 col-xlg-4">
      
       <div v-bind:class="['area_verde']">

       <!-- <div v-show="!mostrarFormularioEdicionFirma"  id="contenedor-filtros-reportederelaciondechequescobrados" class="col-12 col-sm-12 col-md-12 col-lg-4 col-xlg-4">
      <div v-bind:class="[ mostrarFormularioEdicionFirma ? 'wrapDivBloqueado': '']">
       <div v-bind:class="[ mostrarFormularioEdicionFirma ? 'area_verde bloquearDiv': 'area_verde']">    -->   
        
        <div >
       
            <FiltroReporteDeRelacionDeChequesCobrados 
                :catalogos="catalogos" 
                :elementosAOmitir ="elementosAOmitir"
                :elementosAConservar ="elementosAConservar"
                :AccionesMostrar="comportamientoFiltroDeBusquedaFirmas"
                :ejecutalimpiarTablaResultados="limpiarTablaResultados" 
                :ejecutaLaFuncion="buscarDepositoAPI"
                :ejecutaLaFuncion2="buscarDepositoAPI2"
                :ejecutaLaFuncion3="buscarDepositoAPI3"
                :ejecutaLaFuncion4="buscarDepositoAPI4"
                :ejecutaLaFuncion5="buscarDepositoAPI5"
                :tituloDeBusqueda="'Búsqueda de cheques cobrados'"
                v-on:emitGetTipoReporte="tituloSeleccionadodelFiltro = $event"              
                :ref="'filtroBusqueda'">
            </FiltroReporteDeRelacionDeChequesCobrados>

            
      
          </div>
        </div>
      
                     
      </div>
      </transition>
      <!-- Tabla de resultados  -->
      <div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xlg-8  pt-sm-4 pt-md-4 pt-lg-0 pt-xlg-0" id="ProcesadosEncontrados_div">
        <div class="area_verde">
          <transition name="fade">

          <!-- <div v-if="(cheques == undefined || cheques == null || cheques.length <= 0)" style="background-color:var(--gris-pj); padding: 8px;"> -->

          <div v-if="(cheques == undefined || cheques == null || cheques.length <= 0)" style="background-color:var(--gris-pj); padding: 8px;">

            <div class="d-flex justify-content-center">
              <i class="fas fa-file mr-sm-2" style="font-size: 25px;"></i>
              <div class="align-content-center">
                <h5>Reporte de relación de cheques cobrados a encontrar</h5>
                <!-- Esto es lo que se muestra antes de la busqueda -->
              </div>
            </div>
          </div>
          <TablaDeResultadosFirmas 
            v-else-if="cheques != undefined && cheques != null"
            
            v-on:valorParaElPadreAccion="accionRealizar"
            :AccionesMostrar="accionesdelaTablaDeResultadosFirmas"
            :TablaReporteDeRelacionDeChequesCobrados="cheques"
            :TablaReporteDeRelacionDeChequesCobradosFecha="chequesfecha"
            :TablaReporteDeRelacionDeChequesCobradosFechaActual="chequesfechaactual"
            :TablaReporteDeRelacionDeChequesCobradosFechaActual2="chequesfechaactual2"
            v-on:restablecervalores="restablecerValoresDespuesDeGuardarOEliminar"
            :tituloTablaReporteDeRelacionDeChequesCobrados="tituloTablaString"
            >

          </TablaDeResultadosFirmas>
          </transition>
   

        </div>


        


      </div> 




    </div>
    
  </div>
</template>

<script>
import TablaDeResultadosFirmas from '@/components/SIVAC/Comun/TablaDeResultadosFirmas'
import FiltroReporteDeRelacionDeChequesCobrados from '@/components/SIVAC/Comun/FiltroReporteDeRelacionDeChequesCobrados'
import enumeraciones from '@/../static/js/enumeraciones'
import comun from "@/../static/js/comun"
import api from '@/../static/js/api'
import axios from 'axios'




export default {
    components: {
      FiltroReporteDeRelacionDeChequesCobrados,
      TablaDeResultadosFirmas
    },
    
    data(){
      return{
          enumeraciones,
          tituloDeRecibodeFirma:'',
          
          accionesdelaTablaDeResultadosFirmas:{
          alta: true,
          impresion: true,
          cambios: true,
          visualizacion: true,
          altamanual: true,
          bajapersona: true,
          mensaje: true,
          output: null,
          reportes: true,
          consulta: false,
        },

        comportamientoFiltroDeBusquedaFirmas:{            
          administracion: true,
          consulta: false
        },

        catalogos: [          
          
          { catalogoId: enumeraciones.catalogos.EstatusFirma, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_EstatusFirma' },
          { catalogoId: enumeraciones.catalogos.FechaDeInicio, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_FechaInicial' },
          { catalogoId: enumeraciones.catalogos.FechaFinal, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_FechaFinal' },
          { catalogoId: enumeraciones.catalogos.Juzgados, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Area' },
          { catalogoId: enumeraciones.catalogos.Consecutivo, idDelInput: 'filtroDeBusqueda_Consecutivo_Firmas' },
          
        ],
        elementosAOmitir: {
          //materias: [5,10] //áreas de Majat
        },
        cheques: null,
        chequesfecha:null,
        chequesfechaactual:null,
        chequesfechaactual2:null,
        Firma: null,
        FechaInicial: null,
        FechaFinal: null,
        tituloTablaString: '',
        tituloSeleccionadodelFiltro: ''
      }
    },


    computed:{

      elementosAConservar : function()
      {
        let ep = {  
           areas: [1,2,3,4,5,6,7,8,9,10,12,16,20,21,23,28,29,72,73,74,75,76,22,30,78,79,80]
        }
        return ep;
      }
    },


    methods: {
    /** 
     * Metodo encargado de llamar API para búscar Firmas en base a los datos proporcionados.
     */
      buscarDepositoAPI:function() 
      {
        this.chequesfechaactual= null;
        this.chequesfechaactual2= null; 
        const parametros = 
        {
                               
          EsPrueba: this.enumeraciones.EsPrueba,
          
          // Nombre:  this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].nombre) ? this.$refs['filtroBusqueda'].nombre : null,
          // ApellidoPaterno: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].apellido_paterno) ? this.$refs['filtroBusqueda'].apellido_paterno : null,
          // ApellidoMaterno: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].apellido_materno) ? this.$refs['filtroBusqueda'].apellido_materno : null,
          Num_bole: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].certificado_de_deposito) ? this.$refs['filtroBusqueda'].certificado_de_deposito : null,
          Num_cheque: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].numero_de_cheque) ? this.$refs['filtroBusqueda'].numero_de_cheque : null,
          FechaInicial: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].fechaInicial) ? this.$refs['filtroBusqueda'].fechaInicial : null,
          FechaFinal: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].fechaFinal) ? this.$refs['filtroBusqueda'].fechaFinal : null,

          TipoReporte: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].TipoReporte) ? this.$refs['filtroBusqueda'].TipoReporte : null,


          // ,

          // TipoEstatusFirmaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_TipoEstatus.tipoEstatusFirmaId) ? this.$refs['filtroBusqueda'].parametros_TipoEstatus.tipoEstatusFirmaId : null
        }
        // if(this.validarDatosBusquedaProcesado(parametros))
        // {
          comun.SeEstaCargandoInformacion(true); 
          const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);        

          axios.post(api.conexion + api.SIVAC.sistema.reportes.deposito.BuscarChequesPorPeriodoDeFecha, parametros, headerPeticion)
          .then(respuesta => { 
            comun.SeEstaCargandoInformacion(false);
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              this.limpiarTablaResultados();
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              //Cargar Datos de Procesados
              this.cheques = respuesta.data.Cheques;
              this.chequesfecha= respuesta.data;
              this.$nextTick(()=> { PaginarTabla('tablaReporteDeRelacionDeChequesCobradosPaginacion_table', 10)}); 
              // comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
              this.tituloTablaString = this.tituloSeleccionadodelFiltro;
            }         
          })
          .catch(e => {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
        
        // }

      },


          /** 
     * Metodo encargado de llamar API para búscar Firmas en base a los datos proporcionados.
     */
      buscarDepositoAPI2:function() 
      { 
        // this.chequesfecha= null;
        this.chequesfechaactual= null;
        this.chequesfechaactual2= null;
        const parametros = 
        {
                               
          EsPrueba: this.enumeraciones.EsPrueba,
          
          // Nombre:  this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].nombre) ? this.$refs['filtroBusqueda'].nombre : null,
          // ApellidoPaterno: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].apellido_paterno) ? this.$refs['filtroBusqueda'].apellido_paterno : null,
          // ApellidoMaterno: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].apellido_materno) ? this.$refs['filtroBusqueda'].apellido_materno : null,
          Num_bole: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].certificado_de_deposito) ? this.$refs['filtroBusqueda'].certificado_de_deposito : null,
          Num_cheque: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].numero_de_cheque) ? this.$refs['filtroBusqueda'].numero_de_cheque : null,
          TipoReporte: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].TipoReporte) ? this.$refs['filtroBusqueda'].TipoReporte : null

          // ,

          // TipoEstatusFirmaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_TipoEstatus.tipoEstatusFirmaId) ? this.$refs['filtroBusqueda'].parametros_TipoEstatus.tipoEstatusFirmaId : null
        }
        // if(this.validarDatosBusquedaProcesado(parametros))
        // {
          comun.SeEstaCargandoInformacion(true); 
          const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);        

          axios.post(api.conexion + api.SIVAC.sistema.reportes.deposito.BuscarChequesSemanaActual, parametros, headerPeticion)
          .then(respuesta => {
            comun.SeEstaCargandoInformacion(false);
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              this.limpiarTablaResultados();
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              //Cargar Datos de Procesados
              this.cheques = respuesta.data.Cheques;
              this.chequesfecha= respuesta.data;
              this.$nextTick(()=> { PaginarTabla('tablaReporteDeRelacionDeChequesCobradosPaginacion_table', 10)}); 
              // comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
              this.tituloTablaString = this.tituloSeleccionadodelFiltro;
            }         
          })
          .catch(e => {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
        // }
      },



          /** 
     * Metodo encargado de llamar API para búscar Firmas en base a los datos proporcionados.
     */
      buscarDepositoAPI3:function() 
      { 
        // this.chequesfecha= null;
        this.chequesfechaactual= null;
        this.chequesfechaactual2= null;
        const parametros = 
        {
                               
          EsPrueba: this.enumeraciones.EsPrueba,
          
          // Nombre:  this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].nombre) ? this.$refs['filtroBusqueda'].nombre : null,
          // ApellidoPaterno: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].apellido_paterno) ? this.$refs['filtroBusqueda'].apellido_paterno : null,
          // ApellidoMaterno: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].apellido_materno) ? this.$refs['filtroBusqueda'].apellido_materno : null,
          Num_bole: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].certificado_de_deposito) ? this.$refs['filtroBusqueda'].certificado_de_deposito : null,
          Num_cheque: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].numero_de_cheque) ? this.$refs['filtroBusqueda'].numero_de_cheque : null,
          TipoReporte: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].TipoReporte) ? this.$refs['filtroBusqueda'].TipoReporte : null

          // ,

          // TipoEstatusFirmaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_TipoEstatus.tipoEstatusFirmaId) ? this.$refs['filtroBusqueda'].parametros_TipoEstatus.tipoEstatusFirmaId : null
        }
        // if(this.validarDatosBusquedaProcesado(parametros))
        // {
          comun.SeEstaCargandoInformacion(true); 
          const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);        

          axios.post(api.conexion + api.SIVAC.sistema.reportes.deposito.BuscarChequesSemanaAnterior, parametros, headerPeticion)
          .then(respuesta => {
            comun.SeEstaCargandoInformacion(false);
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              this.limpiarTablaResultados();
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              //Cargar Datos de Procesados
              this.cheques = respuesta.data.Cheques;
              this.chequesfecha= respuesta.data;
              this.$nextTick(()=> { PaginarTabla('tablaReporteDeRelacionDeChequesCobradosPaginacion_table', 10)}); 
              // comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
              this.tituloTablaString = this.tituloSeleccionadodelFiltro;
            }         
          })
          .catch(e => {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
        // }
      },



          /** 
     * Metodo encargado de llamar API para búscar Firmas en base a los datos proporcionados.
     */
      buscarDepositoAPI4:function() 
      { 
        this.chequesfecha= null;
        this.chequesfechaactual2= null;
        const parametros = 
        {
                               
          EsPrueba: this.enumeraciones.EsPrueba,
          
          // Nombre:  this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].nombre) ? this.$refs['filtroBusqueda'].nombre : null,
          // ApellidoPaterno: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].apellido_paterno) ? this.$refs['filtroBusqueda'].apellido_paterno : null,
          // ApellidoMaterno: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].apellido_materno) ? this.$refs['filtroBusqueda'].apellido_materno : null,
          // Num_bole: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].certificado_de_deposito) ? this.$refs['filtroBusqueda'].certificado_de_deposito : null,
          Num_cheque: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].numero_de_cheque) ? this.$refs['filtroBusqueda'].numero_de_cheque : null,
          TipoReporte: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].TipoReporte) ? this.$refs['filtroBusqueda'].TipoReporte : null,
          
          // Consecutivo: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].consecutivo) ? this.$refs['filtroBusqueda'].consecutivo : null,
          // AreaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_TipoArea.tipoAreaId) ? this.$refs['filtroBusqueda'].parametros_TipoArea.tipoAreaId : null,

          // ,

          // TipoEstatusFirmaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_TipoEstatus.tipoEstatusFirmaId) ? this.$refs['filtroBusqueda'].parametros_TipoEstatus.tipoEstatusFirmaId : null
        }
        if(this.validarDatosBusquedaProcesado(parametros))
        {
          comun.SeEstaCargandoInformacion(true); 
          const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);        

          axios.post(api.conexion + api.SIVAC.sistema.reportes.deposito.BuscarChequesPorHistorial, parametros, headerPeticion)
          .then(respuesta => {
            comun.SeEstaCargandoInformacion(false);
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              this.limpiarTablaResultados();
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              //Cargar Datos de Procesados
              this.cheques = respuesta.data.Cheques;
              this.chequesfechaactual= respuesta.data;
              this.$nextTick(()=> { PaginarTabla('tablaReporteDeRelacionDeChequesCobradosPaginacion_table', 10)}); 
              // comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
              this.tituloTablaString = this.tituloSeleccionadodelFiltro;
            }         
          })
          .catch(e => {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
        }
      },



           /** 
     * Metodo encargado de llamar API para búscar Firmas en base a los datos proporcionados.
     */
      buscarDepositoAPI5:function() 
      { 
        this.chequesfecha= null;
        this.chequesfechaactual= null;
        const parametros = 
        {
                               
          EsPrueba: this.enumeraciones.EsPrueba,
          
          // Nombre:  this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].nombre) ? this.$refs['filtroBusqueda'].nombre : null,
          // ApellidoPaterno: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].apellido_paterno) ? this.$refs['filtroBusqueda'].apellido_paterno : null,
          // ApellidoMaterno: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].apellido_materno) ? this.$refs['filtroBusqueda'].apellido_materno : null,
          Num_bole: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].certificado_de_deposito) ? this.$refs['filtroBusqueda'].certificado_de_deposito : null,
          TipoReporte: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].TipoReporte) ? this.$refs['filtroBusqueda'].TipoReporte : null,
          
          // Consecutivo: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].consecutivo) ? this.$refs['filtroBusqueda'].consecutivo : null,
          // AreaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_TipoArea.tipoAreaId) ? this.$refs['filtroBusqueda'].parametros_TipoArea.tipoAreaId : null,

          // ,

          // TipoEstatusFirmaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_TipoEstatus.tipoEstatusFirmaId) ? this.$refs['filtroBusqueda'].parametros_TipoEstatus.tipoEstatusFirmaId : null
        }
        if(this.validarDatosBusquedaProcesado(parametros))
        {
          comun.SeEstaCargandoInformacion(true); 
          const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);        

          axios.post(api.conexion + api.SIVAC.sistema.reportes.deposito.BuscarChequesPorHistorial, parametros, headerPeticion)
          .then(respuesta => {
            comun.SeEstaCargandoInformacion(false);
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              this.limpiarTablaResultados();
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              //Cargar Datos de Procesados
              this.cheques = respuesta.data.Cheques;
              this.chequesfechaactual2= respuesta.data;
              this.$nextTick(()=> { PaginarTabla('tablaReporteDeRelacionDeChequesCobradosPaginacion_table', 10)}); 
              // comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
              this.tituloTablaString = this.tituloSeleccionadodelFiltro;
            }         
          })
          .catch(e => {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
        }
      },







      validarDatosBusquedaProcesado: function(datos)
      {
        if( 

            // (datos.TipoEstatusFirmaId == null || datos.TipoEstatusFirmaId == -1) &&
            (datos.Num_bole == null || datos.Num_bole == undefined)
            && (datos.Num_cheque == null || datos.Num_cheque == undefined)
            && ((datos.Consecutivo == null || datos.Consecutivo == undefined) || (datos.AreaId == null || datos.AreaId == undefined)) 
            // &&
            // (datos.Nombre == null || datos.Nombre == undefined) && 
            // (datos.ApellidoPaterno == null || datos.ApellidoPaterno == undefined) && 
            // (datos.ApellidoMaterno == null || datos.ApellidoMaterno == undefined)
             
        )
        {          
            comun.mensajeDeAlerta("Favor de llenar por lo menos un campo del formulario.", null, null);
            return false;
        }




        return true;
       },
       /** 
       * Metodo encargado de verificar que el campo proporcionado tenga un valor valido
       * @param {string/int/other} campo [campo]
       */
      campoRequeridoEsValido: function(campo) 
      {
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },
       /** 
       * Metodo encargado de limpiar los valores de la tabla de resultados.
       */
      limpiarTablaResultados: function()
      {
        this.cheques = null;
      },


      /** 
       * Metodo encargado de limpiar los valores de Firma.
       */
      limpiarValores: function()
      {
        
        this.Firma = null;
        
      },



      /** 
       * Metodo encargado de habilitar los componentes de acuerdo a la acción seleccionada (alta, impresion, alta manual, baja procesado)
       * en la tabla de resultados.
       * @param {object} datos [datos: Accion{Alta, Impresión, Alta Manual y Baja Procesado}]
       */
      accionRealizar:function(datos)
      {



      },














      /**
         * Función encargada de restablecer los valores de la pantalla
         */
      restablecerValoresDespuesDeGuardarOEliminar()
      {
        
        
        this.limpiarValores();
        // this.limpiarTablaResultados(); // para quitar la tabla de resultados
        // this.buscarDepositoAPI();

      },



     // cheques no vigentes = cheques realizadas











     }
    }

</script>

<style scoped>
  .bloquearDiv{
    pointer-events: none;
  }
  .wrapDivBloqueado
  {
    opacity: 0.7;
    cursor: not-allowed;
  }
  .fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.area_verde{
  background-color: var(--verde-pj);
    box-shadow: 0px 6px 20px 4px #161616;
    padding: 25px;
}
</style>


// WEBPACK FOOTER //
// src/components/SIVAC/Reportes/ReporteDeRelacionDeChequesCobrados.vue